export const AccessLevel = {
  Owner: 1000,
  Admin: 100,
  Editor: 10,
  // Viewer = 1,
} as const;

export const AccessLevelToString = (
  level: AccessLevelType | null | undefined
): string => {
  if (!level) return "Unknown";
  switch (level) {
    case AccessLevel.Owner:
      return "Owner";
    case AccessLevel.Admin:
      return "Admin";
    case AccessLevel.Editor:
      return "Editor";
    default:
      return "Unknown";
  }
};

export const AccessLevelFromString = (
  level: string
): AccessLevelType | undefined => {
  switch (level.toLowerCase()) {
    case "owner":
      return AccessLevel.Owner;
    case "admin":
      return AccessLevel.Admin;
    case "editor":
      return AccessLevel.Editor;
    default:
      return undefined;
  }
};

export type AccessLevelType = (typeof AccessLevel)[keyof typeof AccessLevel];
